import React from 'react'
import { ErrorModal } from '../../ui'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect } from '../../../dataHelpers/authenticationHelpers'
import { Table, Badge } from 'reactstrap'
import '../../../stylesheets/Provision.css'
import { Button, Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'
import { ACTIVATE_DISC_LABEL, DEACTIVATE_DISC_LABEL, CONFIRM_HEADER } from '../../../constants'

class DiscountLabelList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            activeTab: '3',
            allDiscountLabelData: [],
            discountId: '',
            discountStatus: '',
            confirmBody: '',
            confirmModal: false
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.fetchAllDiscountLabel = this.fetchAllDiscountLabel.bind(this)
        this.onClick = this.onClick.bind(this)
    }

    async componentDidMount(token) {
        if (this.token) {
            this.fetchAllDiscountLabel(token)
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    async fetchAllDiscountLabel() {
        this.setState({ loading: true })
        let allDiscountList = await subscriptionHelpers.getDiscountLabelList(this.token)
        if (!allDiscountList.error) {
            this.setState({ allDiscountLabelData: allDiscountList, loading: false })
        } else {
            this.setState({ errors: [allDiscountList.error] })
        }
    }

    async openConfirmModal(discountLabelId, status, evt) {
        let discounLabelStatus = true
        let modalBody = ACTIVATE_DISC_LABEL
        if (status === true) {
            discounLabelStatus = false
            modalBody = DEACTIVATE_DISC_LABEL
        }
        this.setState({ confirmModal: true, confirmBody: modalBody, discountId: discountLabelId, discountStatus: discounLabelStatus })
    }

    async onClick() {
        this.setState({ confirmModal: false })
        let discountLabelResponse = await subscriptionHelpers.statusDiscountLabel(this.token, this.state.discountId, this.state.discountStatus)
        if (!discountLabelResponse.error) {
            this.fetchAllDiscountLabel(this.token)
        } else {
            this.setState({ errors: [discountLabelResponse.error] })
        }
    }

    render() {
        let { errors, loading, allDiscountLabelData, confirmModal, confirmBody } = this.state
        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/discountlabelsetting`, this.props.history)) })}
                        >
                            <AddPlanIcon />&ensp;Create Discount Level
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/editdiscountlabel`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Discount Level
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/discountlabellist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Discount Levels
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Available Discount Levels</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <div className="discount-label-list">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Discount Label</th>
                                    <th>Discount Value</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allDiscountLabelData ? allDiscountLabelData.map((discountdata) => (
                                    <tr key={discountdata.id}>
                                        <td>
                                            {discountdata.discount_label}
                                        </td>
                                        <td>{discountdata.discount}</td>
                                        <td>
                                            {discountdata.is_active == true ?
                                                <Badge color="success" style={{ cursor: 'pointer' }} onClick={this.openConfirmModal.bind(this, discountdata.id, discountdata.is_active)}>Active</Badge>
                                                :
                                                <Badge color="danger" style={{ cursor: 'pointer' }} onClick={this.openConfirmModal.bind(this, discountdata.id, discountdata.is_active)}>Inactive</Badge>
                                            }
                                        </td>
                                    </tr>
                                )) :
                                    ''}
                            </tbody>
                        </Table>
                    </div>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
                <Modal isOpen={confirmModal}>
                    <ModalHeader>{CONFIRM_HEADER}</ModalHeader>
                    <ModalBody>
                        {confirmBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.onClick} >OK</Button>
                        <Button color="secondary" onClick={(evt) => this.setState({ confirmModal: false })} >Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>)
    }
}
export default DiscountLabelList



// WEBPACK FOOTER //
// ./src/components/pages/subscription/DiscountLabelList.js